;(function () {
  angular
    .module('contrast.ip')
    .factory('IPBlacklistService', IPBlacklistService)

  function IPBlacklistService(
    $location,
    $translate,
    logger,
    ServiceUtils,
    IPBlacklistModalDeleteService,
    IPBlacklistFactory,
    UserService
  ) {
    'ngInject'

    var trusted = false

    var service = {
      getEnvGroups: getEnvGroups,
      isTrusted: isTrusted,
      setTrusted: setTrusted,
      getAddress: getAddress,
      checkName: checkName,
      checkNameUpdate: checkNameUpdate,
      addAddress: addAddress,
      editAddress: editAddress,
      deleteAddress: deleteAddress,
      openDeleteModal: openDeleteModal,
      routeToIpGrid: routeToIpGrid
    }

    return service

    function getEnvGroups() {
      return [
        { value: 'DEVELOPMENT', text: 'Developement' },
        { value: 'QA', text: 'QA' },
        { value: 'PRODUCTION', text: 'Production' }
      ]
    }

    function isTrusted() {
      return trusted
    }

    function setTrusted(value) {
      trusted = value
    }

    function getAddress(addressUuid) {
      return IPBlacklistFactory.getAddress(addressUuid)
        .then(ServiceUtils.handleResolve('data.address'))
        .catch(ServiceUtils.handleError)
    }

    /**
     * @param addressName
     * @returns {Promise}
     */
    function checkName(addressName) {
      return IPBlacklistFactory.checkName(addressName, isTrusted()).catch(
        function (response) {
          return ServiceUtils.handleError(response, {
            suppressToast: true
          })
        }
      )
    }

    function checkNameUpdate(addressUuid, addressName) {
      return IPBlacklistFactory.checkNameUpdate(
        addressUuid,
        addressName,
        isTrusted()
      ).catch(function (response) {
        return ServiceUtils.handleError(response, {
          suppressToast: true
        })
      })
    }

    /**
     * @param {{}} settings
     * @returns {Promise}
     */
    function addAddress(settings) {
      return IPBlacklistFactory.addAddress(settings)
        .then((_res) => {
          const message = isTrusted()
            ? 'detail_ipAddedToAllowListSuccessMsg'
            : 'detail_ipAddedToDenyListSuccessMsg'
          logger.logSuccess($translate.instant(message))
        })
        .catch(ServiceUtils.handleError)
    }

    /**
     * @param addressUuid
     * @param settings
     * @returns {Promise}
     */
    function editAddress(addressUuid, settings) {
      return IPBlacklistFactory.editAddress(addressUuid, settings).catch(
        ServiceUtils.handleError
      )
    }

    /**
     * @param addressUuid
     * @returns {Promise}
     */
    function deleteAddress(addressUuid) {
      return IPBlacklistFactory.deleteAddress(addressUuid)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    /**
     * @param address
     */
    function openDeleteModal(address) {
      return IPBlacklistModalDeleteService.open(address)
    }

    function routeToIpGrid() {
      if (isTrusted()) {
        $location.path(UserService.buildUrl('/rules/ip/trusted'))
      } else {
        $location.path(UserService.buildUrl('/rules/ip/denylist'))
      }
    }
  }
})()
